/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderhistProfile.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/dispatch/orderhist-profile";

export class AutogenModelOrderhistProfile<RowType extends ModelRow> extends Endpoint<RowType, RowOrderhistProfileFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowOrderhistProfile extends ModelRow<RowOrderhistProfileFields> {
    constructor() {
        super(AutogenUserSavedSearchEndpoint);
    }
}

export interface RowOrderhistProfileFields {
    company_id: string;
    descr: string;
    id: string;
}

